import angular from 'angular';
import _ from 'underscore';
import jQuery from 'jquery';
import moment from 'moment';

function ManageReservationsCtrl($scope, DTColumnDefBuilder, $state, $stateParams, $location, $timeout, $q, pubsubService, printService, modalService, permissionService, venueService, sdkUtils, admissionGroupService, eventService, dateUtilsService, alertService, utilsService, managementUserService, organizationService, managementUserOrganizationMemberService, $sce, layoutService, layoutTableService, RESERVATIONS_VIEW_TYPES, userPreferencesService, availableLayoutTableService, reportService) { //eslint-disable-line
  const currentUser = managementUserService.getCurrentUser();
  const currentUserOrganization = organizationService.getCurrentOrganization();

  userPreferencesService.setManagePage('RESERVATIONS');

  $scope.loading = true;
  $scope.VIEWS = RESERVATIONS_VIEW_TYPES;
  $scope.admissionGroups = [];
  $scope.currentView = $stateParams.viewType || userPreferencesService.getDefaultReservationsView() || $scope.VIEWS.MAP;
  $scope.changeView = _changeView;
  $scope.isExternalOrganization = function() {
    return $scope.venue ? permissionService.isExternalOrganization($scope.venue.organization) : false;
  };
  $scope.canPerformActions = () => {
    return !$scope.isExternalOrganization() && $scope.canWrite;
  };
  $scope.admissionGroupFilterName = 'allconfirmed';
  $scope.canWrite = false;

  $scope.getAdmissionGroupNotes = function(admissionGroup) {
    let notes = `<div>${admissionGroup.notes || ''}`;

    if (admissionGroup.status === 'CANCELLED' && admissionGroup.cancelledNote) {
      if (notes !== '') notes += '<br><br>';
      notes += `<p><strong>Cancelled Notes:</strong></p><p>${admissionGroup.cancelledNote}</p>`;
    }

    notes += '</div>';

    return $sce.trustAsHtml(notes);
  };

  /**
   * @desc Form for the search box
   */
  $scope.reservationListFilterForm = {
    searchTerm: null
  };

  $scope.$watch('reservationListFilterForm.searchTerm', () => {
    if ($scope.reservationListFilterForm.searchTerm) {
      $scope.reservationListFilterForm.searchTerm = $scope.reservationListFilterForm.searchTerm.toLowerCase();
    }
  });

  $scope.changeRequestsView = function($event) {
    if ($event) $event.preventDefault();

    if ($scope.currentView === $scope.VIEWS.MAP) {
      $scope.changeAdmissionGroupFilterName($scope.admissionGroupFilterName === 'pending' ? 'allconfirmed' : 'pending');
    } else {
      $scope.changeAdmissionGroupFilterName($scope.admissionGroupFilterName === 'requests' ? 'allconfirmed' : 'requests');
    }
  };

  $scope.changeAdmissionGroupFilterName = function(filter) {
    $scope.admissionGroupFilterName = filter;

    $scope.reservationListDataTableInstance.DataTable.draw();
  };

  $scope.getServerNameById = function(serverId) {
    const server = _.findWhere($scope.servers, {
      id: serverId
    });

    if (!server) return '';

    return `${server.firstName} ${server.lastName}`;
  };

  // --------------- LIST VIEW ---------------//
  $scope.reservationListDataTableOptions = {
    paginationType: 'full_numbers',
    displayLength: 50,
    columnDefs: [{
        visible: false,
        targets: 0
      }, DTColumnDefBuilder.newColumnDef([7])
      .withTitle('Arrival Time')
      .withOption('type', 'date-time')
    ],
    order: [
      userPreferencesService.getManageReservationSortOrder() || [0, 'asc']
    ],
    drawCallback: function() {
      const api = this.api();
      const rows = api.rows({
        page: 'current'
      }).nodes();
      let last = null;

      api.column(0, {
        page: 'current'
      }).data().each((group, i) => {

        if (last !== group) {
          jQuery(rows).eq(i).before(
            `<tr class="divider"><td colspan="14">${group}</td></tr>`
          );

          last = group;
        }
      });
    }
  };
  $scope.reservationListDataTableInstance = {};
  $scope.reservationListDataTableInstanceCallback = function(dtInstance) {
    $scope.reservationListDataTableInstance = dtInstance;

    dtInstance.DataTable.on('order.dt', () => {
      const orders = dtInstance.DataTable.order();

      if (orders.length) {
        const column = orders[0][0];
        const direction = orders[0][1];

        userPreferencesService.setManageReservationSortOrder(column, direction);
      }
    });
  };

  // --------------- MAP VIEW ---------------//
  $scope.admissionGroupDraggableOptions = {
    appendTo: 'body',
    cursor: 'pointer',
    cursorAt: {
      top: 24,
      left: 30
    },
    helper: _addAdmissionGroupDraggableHelper
  };

  $scope.tableDroppableOptions = {
    activeClass: 'ui-state-default',
    tolerance: 'pointer',
    hoverClass: 'ui-state-hover',
    accept: ':not(.ui-sortable-helper)',
    drop: _handleDrop,
    addClasses: true
  };

  /**
   * @desc on-keyup handler for the search box
   */
  $scope.filterReservationList = function filterReservationList() {
    if ($scope.reservationListDataTableInstance && $scope.reservationListDataTableInstance.DataTable) {
      $scope.reservationListDataTableInstance.DataTable.search($scope.reservationListFilterForm.searchTerm).draw();
    }
  };

  $scope.venuesPromise
    .then(() => {
      $q.all([
          _getPermissions(),
          _getAdmissionGroups(),
          _getLayouts(),
          _getLayoutTables()
        ])
        .then(() => {
          _calculateReservationStatuses();

          if ($stateParams.admissionGroupId) {
            const foundAdmisionGroup = _.findWhere($scope.admissionGroups, {
              id: $stateParams.admissionGroupId
            });
            if (foundAdmisionGroup) $scope.updateAdmissionGroup(foundAdmisionGroup);
          }
        })
        .finally(() => {
          $scope.loading = false;
        });
    });

  $scope.addAdmissionGroup = _addAdmissionGroup;
  $scope.confirmAdmissionGroup = _confirmAdmissionGroup;
  $scope.updateAdmissionGroup = _updateAdmissionGroup;
  $scope.exportData = _exportData;
  $scope.printList = _printList;
  $scope.changeLayout = _changeLayout;
  $scope.removeTableFromAdmissionGroup = _removeTableFromAdmissionGroup;
  $scope.filterReservations = function(admissionGroup) {
    if (!admissionGroup) return false;

    if ($scope.admissionGroupFilterName === 'requests') {
      if (admissionGroup.status === 'PENDING' || admissionGroup.status === 'DENIED') {
        return true;
      }

      return false;
    }
    if ($scope.admissionGroupFilterName === 'pending') {
      if (admissionGroup.status === 'PENDING') {
        return true;
      }

      return false;
    }
    if ($scope.admissionGroupFilterName === 'denied') {
      if (admissionGroup.status === 'DENIED') {
        return true;
      }

      return false;
    }
    if ($scope.admissionGroupFilterName === 'notcheckedin') {
      if (admissionGroup.status === 'PENDING' || admissionGroup.status === 'DENIED') {
        return false;
      } else if (!admissionGroup.arrived) {
        return true;
      }

      return false;
    }
    if ($scope.admissionGroupFilterName === 'checkedin') {
      if (admissionGroup.arrived) {
        return true;
      }

      return false;
    } else if (admissionGroup.status === 'PENDING' || admissionGroup.status === 'DENIED') {
      return false;
    }

    if ($scope.reservationListFilterForm.searchTerm && $scope.reservationListFilterForm.searchTerm.length > 0) {
      if (admissionGroup.tables && admissionGroup.tables.length) {
        let tableContainsSearchTerm = false;

        for (let i = 0; i < admissionGroup.tables.length; i++) { //eslint-disable-line
          if (admissionGroup.tables[i].name && admissionGroup.tables[i].name.toLowerCase && admissionGroup.tables[i].name.toLowerCase() === $scope.reservationListFilterForm.searchTerm.toLowerCase()) {
            tableContainsSearchTerm = true;
            break;
          }
        }

        if (tableContainsSearchTerm) return true;
      }

      if (admissionGroup.name && admissionGroup.name.toLowerCase && admissionGroup.name.toLowerCase().indexOf($scope.reservationListFilterForm.searchTerm) > -1) return true;

      if (admissionGroup.attributionName) {
        if (admissionGroup.attributionName.toLowerCase && admissionGroup.attributionName.toLowerCase().indexOf($scope.reservationListFilterForm.searchTerm) > -1) return true;
      }

      if (admissionGroup.serverName) {
        if (admissionGroup.serverName.toLowerCase && admissionGroup.serverName.toLowerCase().indexOf($scope.reservationListFilterForm.searchTerm) > -1) return true;
      }

      return false;
    }

    return true;
  };
  $scope.printAdmissionGroup = function(admissionGroup, $event) {
    if (!admissionGroup) return;
    if ($event) $event.preventDefault();

    printService.printAdmissionGroup(admissionGroup, $scope.venue);
  };

  pubsubSubscribe();

  // ----------------------- private helpers ----------------------- //

  function _getPermissions() {
    const canWrite = permissionService.canWriteReservations($scope.venue.id);

    return $q.all({
      canWrite
    }).then(results => {
      $scope.canWrite = results.canWrite;
    });
  }

  function _removeTableFromAdmissionGroup(table, admissionGroup, $event) {
    if (!table || !admissionGroup) return;
    if ($event) $event.preventDefault();

    admissionGroupService.updateById(admissionGroup.id, {
        tables: _.reject(admissionGroup.tables, function(el) {
          return el.id === table.id;
        })
      })
      .then(function(updatedAdmissionGroup) {
        updateLayoutTablesByAdmissionGroup(admissionGroup);

        _.extend(admissionGroup, updatedAdmissionGroup);

        alertService.success('Table removed from reservation.');
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }

  function _changeLayout(layout, $event) {
    if ($event) $event.preventDefault();

    $scope.currentLayout = layout;
  }

  function _addAdmissionGroupDraggableHelper(event) {
    const foundAdmisionGroup = _.findWhere($scope.admissionGroups, {
      id: jQuery(event.currentTarget).attr('data-id')
    });

    if (!foundAdmisionGroup) return null;

    return jQuery(`<div style="opacity:0.8; background:#666;color:#FFFFFF;display:block; z-index:100000;text-transform:capitalize;" class="ui-widget-header">
      ${foundAdmisionGroup.name}
      </div>`);
  }

  function _handleDrop(event, ui) {
    const tableId = jQuery(this).attr('data-id');
    const admissionGroupId = ui.draggable.attr('data-id');

    const layoutTable = _.findWhere($scope.layoutTables, {
      id: tableId
    });

    const admissionGroup = _.findWhere($scope.admissionGroups, {
      id: admissionGroupId
    });

    const tableObj = {
      name: layoutTable.name,
      id: layoutTable.id
    };

    if (admissionGroup.tables) {
      for (let i = admissionGroup.tables.length - 1; i >= 0; i--) { //eslint-disable-line
        if (admissionGroup.tables[i].id === layoutTable.id) {
          alertService.error('This guest is already assigned to this table.');

          return false;
        }
      }
    }

    admissionGroup.tables = _.union(admissionGroup.tables || [], [tableObj]);

    admissionGroupService.updateById(admissionGroup.id, {
        tables: admissionGroup.tables
      })
      .then(updatedAdmissionGroup => {
        _.extend(admissionGroup, updatedAdmissionGroup);

        _calculateReservationStatuses();

        _getLayoutTableById(layoutTable.id);
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });

    return true;
  }

  function _calculateReservationStatuses() {
    let totalPending = 0;
    let totalDenied = 0;
    let totalRequests = 0;
    let totalConfirmed = 0;
    let totalCheckedIn = 0;
    let totalNotCheckedIn = 0;

    _.each($scope.admissionGroups, admissionGroup => {
      if (admissionGroup.status === 'PENDING') {
        totalPending++; //eslint-disable-line
        totalRequests++; //eslint-disable-line
      } else if (admissionGroup.status === 'DENIED') {
        totalDenied++; //eslint-disable-line
        totalRequests++; //eslint-disable-line
      } else if (admissionGroup.status !== 'DENIED') {
        totalConfirmed++; //eslint-disable-line
        if (admissionGroup.arrived) {
          totalCheckedIn++; //eslint-disable-line
        } else {
          totalNotCheckedIn++; //eslint-disable-line
        }
      }
    });

    $scope.totalPending = totalPending;
    $scope.totalDenied = totalDenied;
    $scope.totalRequests = totalRequests;
    $scope.totalConfirmed = totalConfirmed;
    $scope.totalCheckedIn = totalCheckedIn;
    $scope.totalNotCheckedIn = totalNotCheckedIn;
  }

  function _changeView(view, $event) {
    if (!view) return;
    if ($event) $event.preventDefault();

    $scope.currentView = view;

    //list view only shows requests all together, so filter to all requests, not just pending or denied
    if ($scope.currentView === $scope.VIEWS.LIST && ($scope.admissionGroupFilterName === 'pending' || $scope.admissionGroupFilterName === 'denied')) {
      $scope.changeAdmissionGroupFilterName('requests');
    }

    if ($scope.currentView === $scope.VIEWS.MAP && ($scope.admissionGroupFilterName === 'requests')) {
      $scope.changeAdmissionGroupFilterName('pending');
    }

    userPreferencesService.setDefaultReservationsView($scope.currentView);
  }

  function _printList($event) {
    if ($event) $event.preventDefault();

    let printGuests = _.filter($scope.admissionGroups, v => v.status !== 'PENDING');

    const selectedGuests = getSelectedAdmissionGroups();

    if (selectedGuests.length) {
      printGuests = selectedGuests;
    }

    const defaultSortOrder = userPreferencesService.getManageReservationSortOrder() || [0, 'asc'];
    let sortOrder = 'name';
    let sortDirection = '';

    if (defaultSortOrder.length) {
      const column = defaultSortOrder[0];
      sortDirection = defaultSortOrder[1];

      if (column === 2) {
        sortOrder = 'name';
      } else if (column === 3) {
        sortOrder = 'minimumSpend';
      } else if (column === 4) {
        sortOrder = 'spent';
      } else if (column === 5) {
        sortOrder = 'inventoryName';
      } else if (column === 6) {
        sortOrder = 'name';
      } else if (column === 7) {
        sortOrder = 'arrivalTime';
      } else if (column === 10) {
        sortOrder = 'serverName';
      } else if (column === 11) {
        sortOrder = 'attributionName';
      }
    }

    const sortedGuests = sortOrder === 'arrivalTime' ?
      printGuests.sort((a, b) => {
        a = moment.utc(a.arrivalTime);
        b = moment.utc(b.arrivalTime);

        if (a.isBefore(b)) {
          return -1;
        } else if (b.isBefore(a)) {
          return 1;
        }
        return 0;
      }) :
      _.sortBy(printGuests, sortOrder);

    if (sortDirection === 'desc') {
      sortedGuests.reverse();
    }

    const context = {
      guests: sortedGuests,
      event: event,
      venue: $scope.venue,
      date: $scope.currentDateUTC,
      total_guest: $scope.total_guest,
      male_ratio: jQuery('.male-ratio').text(),
      female_ratio: jQuery('.female-ratio').text(),
      printing: true
    };

    printService.printTemplate(printService.TEMPLATES.RESERVATION_EXPORT, context);
  }

  function pubsubSubscribe() {
    const reservationChannel = `${pubsubService.CHANNELS.NP_COMPANY_RESERVATION}${$scope.venue.organization}`;
    const layoutTableChannel = `${pubsubService.CHANNELS.NP_COMPANY_AVAILABLE_LAYOUT_TABLE}${$scope.venue.organization}`;

    if (!$scope.isExternalOrganization()) {
      $scope.pubsubReservationClient = pubsubService.subscribe(reservationChannel, message => {
        if (!$scope.venue) return;

        //ignore messages from the same person
        if (message.userId !== currentUser.id && message.venueId === $scope.venue.id) {
          const messageDate = moment.utc(message.date);

          if (message.type === 'TABLE' && messageDate.format('DD-MM-YY') === moment($scope.currentDateUTC).format('DD-MM-YY')) {
            _handlePubsub(message.admissionGroupId);
          }
        }
      });
    }

    $scope.pubsubLayoutTablesClient = pubsubService.subscribe(layoutTableChannel, message => {
      if (message && message.id) {
        const foundTable = _.findWhere($scope.layoutTables, {
          id: message.id
        });

        if (foundTable) {
          _.extend(foundTable, message);
        }
      }
    });

    $scope.$on('$destroy', () => {
      $scope.pubsubReservationClient.unsubscribe({
        channels: [reservationChannel]
      });

      $scope.pubsubLayoutTablesClient.unsubscribe({
        channels: [layoutTableChannel]
      });
    });
  }

  function _exportData($event) {
    if ($event) $event.preventDefault();

    const admissionGroupIds = getSelectedAdmissionGroupIds();

    const options = {
      fileType: 'CSV',
      organizationId: currentUserOrganization.id,
      reportType: 'TLPRO_RESERVATION_DUMP',
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
    };

    if ($scope.event) {
      options.eventId = $scope.event.id;
    }

    if ($scope.venue) {
      options.venueId = $scope.venue.id;
    }

    if (admissionGroupIds.length) {
      options.admissionGroupId = admissionGroupIds;
    }

    return reportService.create(options);
  }

  function _getLayouts() {
    return layoutService.listByVenueId($scope.venueId)
      .then(layouts => {
        $scope.layouts = _.sortBy(layouts, 'order');
        $scope.currentLayout = $scope.layouts && $scope.layouts.length ? $scope.layouts[0] : null;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getLayoutTables() {
    return availableLayoutTableService.listByVenueId($scope.venueId, {
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      })
      .then(layoutTables => {
        $scope.layoutTables = layoutTables;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getLayoutTableById(id) {
    return availableLayoutTableService.readById(id, {
        date: $scope.currentDateUTC.format('x')
      })
      .then(layoutTable => {
        const foundTable = _.findWhere($scope.layoutTables, {
          id
        });

        if (foundTable) {
          _.extend(foundTable, layoutTable);
        }
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function updateLayoutTablesByAdmissionGroup(admissionGroup) {
    if (!admissionGroup || !admissionGroup.tables || !admissionGroup.tables.length) return null;

    const tableIds = admissionGroup.tables.map(table => table.id);

    return availableLayoutTableService.listByVenueId($scope.venueId, {
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        tableId: tableIds
      })
      .then(layoutTables => {
        layoutTables.forEach(table => {
          const foundTable = _.findWhere($scope.layoutTables, {
            id: table.id
          });

          if (foundTable) {
            _.extend(foundTable, table);
          }
        });
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _confirmAdmissionGroup(admissionGroup, $event) {
    if (!admissionGroup) return;

    if ($event) $event.preventDefault();

    modalService.addAdmissionGroup({
        type: 'TABLE',
        admissionGroup: admissionGroup,
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        events: $scope.events,
        organizationId: currentUserOrganization.id,
        onAddedOrUpdated: function(result) {
          if (!result || !result.admissionGroup) return;

          if (!result.created) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            if (existingAdmissionGroup) _.extend(existingAdmissionGroup, result.admissionGroup);
          } else {
            $scope.admissionGroups.push(result.admissionGroup);
          }

          _calculateAdmissionGroupTotals();

          _calculateReservationStatuses();

          updateLayoutTablesByAdmissionGroup(result.admissionGroup);

          if (result.notify !== false) alertService.success('Reservation saved');
        }
      })
      .catch(() => {
        alertService.error('There was an error creating or updating an admission group');
      });
  }

  function _updateAdmissionGroup(admissionGroup, tabName, $event) {
    if (!admissionGroup) return;

    if ($event) $event.preventDefault();

    modalService.addAdmissionGroup({
        type: 'TABLE',
        admissionGroup: admissionGroup,
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        events: $scope.events,
        organizationId: currentUserOrganization.id,
        currentTab: tabName,
        onAddedOrUpdated: function(result) {
          if (!result || !result.admissionGroup) return;

          updateLayoutTablesByAdmissionGroup(admissionGroup);

          if (result.deleted) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);

            $scope.admissionGroups.splice(index, 1);
          } else if (!result.created) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            if (result.admissionGroup.date !== existingAdmissionGroup.date) {
              //remove the admission group because it's date changed
              const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);
              $scope.admissionGroups.splice(index, 1);

              const admissionGroupDate = moment.utc(result.admissionGroup.date, 'x');

              modalService.admissionGroupNotVisible({
                modalHeader: `Reservation date has been changed to ${admissionGroupDate.format('ddd. MMMM Do')} and is no longer visible.`,
                onBtnClick: function() {
                  $state.go($state.current.name, {
                    date: result.admissionGroup.date,
                    venueId: $scope.venueId
                  }, {
                    reload: true
                  });
                }
              });
            } else if (existingAdmissionGroup) {
              _.extend(existingAdmissionGroup, result.admissionGroup);
            }
          } else {
            $scope.admissionGroups.push(result.admissionGroup);
          }

          _calculateAdmissionGroupTotals();

          _calculateReservationStatuses();

          _mapAdmissionGroups();

          $scope.admissionGroups = angular.copy($scope.admissionGroups); //needed to force datatables to fully redraw

          if (result.notify !== false) alertService.success(result.deleted ? 'Reservation deleted' : 'Reservation saved');
        }
      })
      .catch(() => {
        alertService.error('There was an error creating or updating an admission group');
      });
  }

  function _addAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    $scope.currentAdmissionGroup = null;

    $scope.selectedSuggestion = null;

    modalService.addAdmissionGroup({
        type: 'TABLE',
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        events: $scope.events,
        organizationId: currentUserOrganization.id,
        onAddedOrUpdated: function(result) {
          if (!result || !result.admissionGroup) return;

          if (!result.created) {
            const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
              id: result.admissionGroup.id
            });

            if (existingAdmissionGroup) _.extend(existingAdmissionGroup, result.admissionGroup);
          } else {
            $scope.admissionGroups.push(result.admissionGroup);
          }

          _calculateAdmissionGroupTotals();

          _calculateReservationStatuses();

          updateLayoutTablesByAdmissionGroup(result.admissionGroup);

          _mapAdmissionGroups();

          $scope.refreshAdmissionGroupStats();

          alertService.success(result.created ? 'Reservation added.' : 'Reservation saved.');
        }
      })
      .catch(() => {
        alertService.error('There was an error updating or creating an admission group');
      });
  }

  function _getAdmissionGroups() {
    const options = {
      venue: $scope.venueId,
      event: $scope.event ? $scope.event.id : null,
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      type: ['TABLE'],
      limit: 3000
    };

    return admissionGroupService.list(options)
      .then(admissionGroups => {
        $scope.admissionGroups = admissionGroups;

        _mapAdmissionGroups();

        _calculateAdmissionGroupTotals();
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function getSelectedAdmissionGroups() {
    return _.where($scope.admissionGroups, {
      selected: true
    });
  }

  function getSelectedAdmissionGroupIds() {
    const selectedAdmissionGroups = getSelectedAdmissionGroups();
    return _.map(selectedAdmissionGroups, group => group.id);
  }

  function _handlePubsub(admissionGroupId) {
    $q.all([
        admissionGroupService.readById(admissionGroupId),
        _getLayoutTables()
      ])
      .then(results => {
        const admissionGroup = results[0];

        const foundAdmisionGroup = _.findWhere($scope.admissionGroups, {
          id: admissionGroup.id
        });

        if (foundAdmisionGroup) {
          angular.extend(foundAdmisionGroup, admissionGroup);
        } else {
          $scope.admissionGroups.unshift(admissionGroup);
        }

        //if it was added by the current user don't show the alert
        if (admissionGroup.addedBy && admissionGroup.addedByDetails && admissionGroup.addedBy === currentUser.id) return;

        if (!foundAdmisionGroup) {
          if (admissionGroup.addedBy && admissionGroup.addedByDetails) {
            alertService.success(admissionGroup.name + " was just added by " + admissionGroup.addedByDetails.first_name + " " + admissionGroup.addedByDetails.last_name); //eslint-disable-line
          } else {
            alertService.success(admissionGroup.name + " was just added."); //eslint-disable-line
          }
        } else {
          alertService.success(admissionGroup.name + " was just updated."); //eslint-disable-line
        }

        _calculateAdmissionGroupTotals();

        _calculateReservationStatuses();
      })
      .catch(response => {
        sdkUtils.getErrorFromResponse(response);
      });
  }

  function _calculateAdmissionGroupTotals() {
    $scope.getAdmissionGroupStats();
  }

  function _mapAdmissionGroups() {
    _.map($scope.admissionGroups, admissionGroup => {
      if (admissionGroup.event) {
        const event = $scope.eventsIndexedById[admissionGroup.event];
        admissionGroup.eventName = event ? event.name : 'No Event';
      } else {
        admissionGroup.eventName = 'No Event';
      }

      admissionGroup.fullNotes = $scope.getAdmissionGroupNotes(admissionGroup);
    });
  }
}

ManageReservationsCtrl.$inject = [
  '$scope',
  'DTColumnDefBuilder',
  '$state',
  '$stateParams',
  '$location',
  '$timeout',
  '$q',
  'pubsubService',
  'printService',
  'modalService',
  'permissionService',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.admissionGroup',
  'jsSdk.event',
  'dateUtilsService',
  'alertService',
  'utilsService',
  'jsSdk.managementUser',
  'organizationService',
  'managementUserOrganizationMemberService',
  '$sce',
  'jsSdk.layout',
  'jsSdk.layoutTable',
  'RESERVATIONS_VIEW_TYPES',
  'userPreferencesService',
  'jsSdk.availableLayoutTable',
  'reportService'
];

export default ManageReservationsCtrl;



// WEBPACK FOOTER //
// ./src/components/manageReservations/manageReservationsCtrl.js